// extracted by mini-css-extract-plugin
module.exports = {"root":"_161aa9","spacerContainer":"_da8138","spacer":"_05f34a","masonry":"_26820f","column":"_8fe6da"};